module.exports = __webpack_public_path__ + "bfa30d18a87d6fd69f9bdf1373669c6d.png";